import { Helmet } from 'react-helmet-async';
import { useLocales } from 'src/locales';
import { CategoryDetailsHomeView } from 'src/sections/blog/view';
// sections

// ----------------------------------------------------------------------

export default function CategoryDetailsHomePage() {
  const { isRTL } = useLocales();

  return (
    <>
      <Helmet>
        <title> category: Details</title>
      </Helmet>

      <CategoryDetailsHomeView isRTL={isRTL} />
    </>
  );
}
